import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SharedService } from '../../../../../shared/sharedServices/shared.service';
import { ProfileComponent } from '../../profile.component';
import { HecResponse } from '../../../../../shared/shared-interfaces/hecResponse';
import { HEC_CONSTANTS } from '../../../../../utilities/constants';
import { CommonHelper } from '../../../../../utilities/common.helper';
import { Router } from '@angular/router';
import { LoaderService } from '../../../../../shared/sharedServices/loader.service';

@Component({
	selector: 'kt-change-password',
	templateUrl: './change-password.component.html',
	styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
	@ViewChild('passwordUpdateForm', { static: false }) passwordUpdateForm: NgForm;
	public isAlertVisible: boolean = false;
	public alertType: string;
	public alertIcon: string;
	public alertMsgValue: string;
	public sendCode: boolean = false;
	public timer;
	public resendCodeSeconds: boolean = false;
	public newPassword: string;
	public confirmNewPassword: string;
	public wrongConfirmPassword: boolean = false;
	@ViewChild('seconds', { static: false }) elementView: ElementRef;

	constructor(private sharedServices: SharedService, private cdr: ChangeDetectorRef,
		private profileComp: ProfileComponent, private router: Router, private loaderService:LoaderService) { }

	ngOnInit() {
		window.scroll(0,0)
		this.isAlertVisible = true;
		this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.profileMessages.PASSWORD_WARNING;
		this.alertType = HEC_CONSTANTS.ERROR_TYPES.warning;
	}

	public submitUserRequest() {
		this.isAlertVisible = false;
		this.markFormsTouched(this.passwordUpdateForm)
		if (this.validate(this.passwordUpdateForm.form.controls.o_password) && (this.passwordUpdateForm.form.controls.n_password) &&
			(this.passwordUpdateForm.form.controls.c_password)) {
			// this.profileComp.loader = true;
			this.loaderService.setValue(true)
			let payload = {
				"data": {
					oldPassword: this.passwordUpdateForm.value.o_password,
					newPassword: this.passwordUpdateForm.value.n_password
				}
			}
			this.sharedServices.updatePassword(payload).subscribe(
				(res: HecResponse) => {
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						if (res.data == true) {
							this.isAlertVisible = true;
							this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.PASSWORD_UPDATED;
							this.alertType = HEC_CONSTANTS.ERROR_TYPES.success;
							// this.profileComp.loader = false;	
							this.loaderService.setValue(false)
							this.cdr.detectChanges();
							this.cdr.markForCheck();
							setTimeout(()=>{
								this.logout();
							},3000)

						} else {
							// this.profileComp.loader = false;
							this.loaderService.setValue(false)
							this.isAlertVisible = true;
							this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.profileMessages.OLD_PASSWORD_INVALID;
							this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
							this.cdr.detectChanges();
							this.cdr.markForCheck();
						}
					} else if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.ALREADY_EXIST) {
						this.isAlertVisible = true;
						this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.profileMessages.OLD_PASSWORD_INVALID;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						// this.profileComp.loader = false;
						this.loaderService.setValue(false)
						this.cdr.detectChanges();
					}
					else {
						this.isAlertVisible = true;
						this.alertMsgValue = res.statusDescription;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						// this.profileComp.loader = false;
						this.loaderService.setValue(false)
						this.cdr.detectChanges();
					}
				},
				(err) => {
					this.isAlertVisible = true;
					this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.SOMETHING_ERROR;
					this.alertType = HEC_CONSTANTS.ERROR_TYPES.error
					// this.profileComp.loader = false;
					this.loaderService.setValue(false)
					this.cdr.detectChanges();
				}
			)
		}
	}

	public getPassword(password) {
		this.newPassword = password
		if(this.confirmNewPassword != undefined && this.newPassword == this.confirmNewPassword){
			this.wrongConfirmPassword = false;
			this.passwordUpdateForm.form.controls.c_password.setErrors(null)
			this.cdr.detectChanges();
		}else{
			if(this.passwordUpdateForm.form.controls.c_password.valid){
			this.wrongConfirmPassword = true;
			this.passwordUpdateForm.form.controls.c_password.setErrors({ mustMatch: true })
			this.cdr.detectChanges();
		}
		}
	}
	public getConfirmPassword(cPassword) {
		this.confirmNewPassword = cPassword;
		if (this.passwordUpdateForm.form.controls.c_password.valid && this.newPassword != this.confirmNewPassword) {
			this.passwordUpdateForm.form.controls.c_password.setErrors({ mustMatch: true })
			this.wrongConfirmPassword = true;
			this.cdr.detectChanges();
		} else {
			this.wrongConfirmPassword = false;
			this.passwordUpdateForm.form.controls.c_password.setErrors(null)
		}
	}

	public logout() {
		this.sharedServices.logoutUser().subscribe(
			(res) => {
				if (res['statusCode'] == 200) {
					localStorage.removeItem('esp-profile-details');
					localStorage.removeItem('ng2Idle.main.expiry');
					localStorage.removeItem('eduHistory');
					localStorage.removeItem('dob');
					localStorage.removeItem('loginDetails');
					localStorage.removeItem('addresses');
					localStorage.removeItem('primaryNationality');
					localStorage.removeItem('name');
					localStorage.removeItem('Avatar');
					localStorage.removeItem('esp-menu-list');
					localStorage.removeItem('login');
					localStorage.removeItem('jwt');

					// this.idle.stop();
					document.cookie = "profile=; _ga=0; path=/"
					this.router.navigate(['/auth/login'])
				}
			}
		)
	}

	public markFormsTouched(form): void {
		CommonHelper.markFormGroupTouched(form);
	}

	public validate(f): boolean {
		if (f.status === 'VALID') {
			return true;
		}
	}

	


}
